module.exports = __webpack_public_path__ + "img/0Q3B8790-7_H_Black_MockedUp.e61f83ae.jpg";